import { render, staticRenderFns } from "./SingleView.vue?vue&type=template&id=f1dfabae&scoped=true&"
import script from "./SingleView.vue?vue&type=script&lang=js&"
export * from "./SingleView.vue?vue&type=script&lang=js&"
import style0 from "./SingleView.vue?vue&type=style&index=0&id=f1dfabae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dfabae",
  null
  
)

component.options.__file = "SingleView.vue"
export default component.exports